<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}} <span v-if="isAdmin" class="text-danger">({{userType}})</span> <b-badge pill variant="success" v-if="getUserType">{{getUserType}}</b-badge></h5>
      <div class="pull-right" v-if="section === ''">
        <b-button v-if="canImpersonate" variant="primary" @click="startImpersonate(detailedInfo.id)" class="mr-2">Impersonate</b-button>
        <b-button v-if="canEdit" variant="outline-primary" @click="section = 'edit'"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"           :active="section === ''"                   >Preview</b-nav-item>
        <b-nav-item @click="section = 'features'"   :active="section === 'features'"   disabled>Features</b-nav-item>
        <b-nav-item @click="section = 'additional'" :active="section === 'additional'"         >Additional Data</b-nav-item>
        <b-nav-item @click="section = 'assign_vehicle'" :active="section === 'assign_vehicle'" :disabled="!checkAccess('assign_vehicle')" >Assign Vehicle</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
import userMixin from '@/mixins/user';
import { isEmpty, capitalize } from 'lodash';

export default {
  name: 'user_detail',
  mixins: [userMixin],
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
    };
  },
  created() {
    const { userId } = this.$route.params;
    this.$store.commit('users/SET_DETAIL_ID', userId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'users', name: 'Users' },
      { to: userId, name: 'Detail' },
    ]);
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['users/get_detail_data'];
    },
    displayName() {
      return this.detailedInfo.full_name;
    },
    userType() {
      const { type } = this.detailedInfo;
      switch (type) {
        case 'SYSTEM_ADMIN':
          return 'System Admin';
        case 'ADMIN':
          return 'Admin';
        default:
          return 'User';
      }
    },
    isAdmin() {
      return this.detailedInfo.type === 'ADMIN' ||
        this.detailedInfo.type === 'SYSTEM_ADMIN';
    },
    canImpersonate() {
      return !this.$store.getters.impersonating &&
        this.amISuperior(this.detailedInfo);
    },
    canEdit() {
      return this.amISuperior(this.detailedInfo);
    },
    getUserType() {
      const { employee, vehicle } = this.detailedInfo;
      let type = false;

      if (!isEmpty(employee) || !isEmpty(vehicle)) {
        type = isEmpty(vehicle) ? capitalize(employee.type) : 'Vehicle';
        if (type !== 'Loader' && type !== 'Driver' && type !== 'Vehicle') type = false;
      }

      return type;
    },
  },
  watch: {
    section(newSection) {
      const { userId } = this.$route.params;
      this.$router.push(`/admin/users/${userId}/${newSection}`);
    },
  },
  methods: {
    checkAccess(feature) {
      if (feature === 'assign_vehicle') {
        return !this.isAdmin && !['Driver', 'Loader'].includes(this.getUserType);
      }
      return true;
    },
  },
};
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/pages/admin/users/Detail.vue